import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import env from '@tencent/vft-common/env';
import util from '@tencent/vft-common/util';
import { CHANNEL_CONFIG } from "./const";
var supportedKidVersion = '6.4.0'; // 浏览器sdk

export var loadMqbSdk = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve) {
              util.loadScript('mqb-sdk', '//jsapi.qq.com/get?api=app.share', function () {
                resolve();
              });
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loadMqbSdk() {
    return _ref.apply(this, arguments);
  };
}(); // 腾讯新闻

export var loadQQNewSdk = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!env.isAndroid) {
              _context2.next = 5;
              break;
            }

            _context2.next = 3;
            return new Promise(function (resolve) {
              util.loadScript('qqnews-sdk', '//mat1.gtimg.com/www/js/newsapp/jsapi/news.js?_tsid=1', function () {
                console.log("window.TencentNews", window.TencentNews);
                console.log("window.TencentNews.injectionComplete", window.TencentNews.injectionComplete);
                resolve();
              });
            });

          case 3:
            _context2.next = 7;
            break;

          case 5:
            _context2.next = 7;
            return new Promise(function (resolve) {
              setTimeout(function () {
                console.log("300ms到了");
                console.log("window.TencentNews", window.TencentNews);
                console.log("window.TencentNews.injectionComplete", window.TencentNews.injectionComplete);
                resolve();
              }, 300);
            });

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function loadQQNewSdk() {
    return _ref2.apply(this, arguments);
  };
}(); // 微视

export var loadWeiShiSdk = function loadWeiShiSdk() {
  if (window.H5_SHARE) return Promise.resolve();
  return new Promise(function (resolve) {
    util.loadScript('weishi-sdk', '//isee.weishi.qq.com/iseecdn/static/js/wesee-h5-share.js', resolve);
  });
}; // QQ

export var loadMqqSdk = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return new Promise(function (resolve) {
              util.loadScript('mqq-sdk', '//pub.idqqimg.com/qqmobile/qqapi.js?_bid=152', function () {
                resolve();
              });
            });

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function loadMqqSdk() {
    return _ref3.apply(this, arguments);
  };
}(); // QQ音乐

export var loadMusicSdk = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return new Promise(function (resolve) {
              util.loadScript('music-sdk', '//y.gtimg.cn/music/h5/client/jsbridge.js', function () {
                resolve();
              });
            });

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function loadMusicSdk() {
    return _ref4.apply(this, arguments);
  };
}(); // 按环境获取分享渠道配置

export var getChannelConfigByEnv = function getChannelConfigByEnv(_ref5) {
  var originEnv = _ref5.originEnv,
      appVersion = _ref5.appVersion,
      usePwd = _ref5.usePwd;
  var env = originEnv;

  if (env === 'kidapp') {
    // 小企鹅6.4.0版本以下只支持分享链接 且只能分享微信 朋友圈
    // 小企鹅6.4.0版本以后支持分享图片，且可以保存本地
    if (appVersion.compare(supportedKidVersion)) {
      env = 'kidappSupported';
    }
  }

  return getDefaultChannelConfig({
    channelAbbreviations: CHANNEL_CONFIG[env],
    usePwd: usePwd
  }) || [];
};

var getDefaultChannelConfig = function getDefaultChannelConfig(_ref6) {
  var channelAbbreviations = _ref6.channelAbbreviations,
      usePwd = _ref6.usePwd;
  var channelsMap = new Map([['save', {
    id: 'save'
  }], ['weixin', {
    id: 'weixin',
    usePwd: usePwd
  }], ['wxmoments', {
    id: 'wxmoments',
    usePwd: usePwd
  }], ['doki', {
    id: 'doki'
  }], ['qzone', {
    id: 'qzone'
  }], ['qq', {
    id: 'qq'
  }], ['weibo', {
    id: 'weibo'
  }], ['weixinNoPwd', {
    id: 'weixin'
  }], ['wxmomentsNoPwd', {
    id: 'wxmoments'
  }]]);
  return channelAbbreviations.map(function (channel) {
    return channelsMap.get(channel);
  });
};